import routes from '../routes'
import {
  fromDoorstepInjectedEnvironment,
  isLocal as isInLocal,
  isStaging as isInStaging,
} from '../utilities/environment'
import * as queryString from 'query-string'
import { Application } from '../utilities/application/application'
import { getUtmSource } from '../utilities/utmSource'

/**
 * Handles redirect to Identity Signup
 * @param application {Application} Dasher Applicant application object
 * @param params {object} Query params to pass through
 */
export const handleSignupRedirect = (
  application: Partial<Application>,
  params?: { [key: string]: string }
): void => {
  const isLocal = isInLocal(fromDoorstepInjectedEnvironment(window))
  const isStaging = isInStaging(fromDoorstepInjectedEnvironment(window))

  const queryParams = queryString.stringify({
    uniqueLink: application.uniqueLink,
    email: application.email,
    phone: application.phoneNumber,
    countryCode: application.country,
    referredById: application.referredById,
    hasConsumerAccount: application.hasConsumerAccount,
    utmSource: getUtmSource(),
    ...params,
  })

  if (isLocal) {
    // Run local BFF to use this
    window.location.assign(
      `http://localhost:8080${routes.signup.path}?${queryParams}`
    )
  } else if (isStaging) {
    window.location.assign(
      `https://doorcrawl.com${routes.signup.path}?${queryParams}`
    )
  } else {
    window.location.assign(`${routes.signup.path}?${queryParams}`)
  }
}
